// Utility function to modify the URL
export const changeReferenceUrl = (proposalId: number, reference: string, inn: string, cid: string): string => {

  let modifiedReference = reference;

  if (proposalId === 1267) {
    const url = new URL(modifiedReference);
    const params = new URLSearchParams(url.search);
    params.set('utm_term', inn);
    params.set('utm_content', cid);
    url.search = params.toString();
    modifiedReference = url.toString();
  }
  return modifiedReference;
};
